import { useState } from "react";
import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import Hero from "@/pages/home/components/Hero";
import HotGossip from "@/pages/home/components/HotGossip";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeedSection from "@/pages/home/components/FeedSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import VoiceSection from "@/pages/home/components/VoiceSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactSection from "@/pages/home/components/ContactSection";
import useSeo from "@/hooks/useSeo";
import { faqs, feedItems, siteMeta } from "@/mocks/gossip";

const SITE_URL = "https://royoug.cn/";

export default function Home() {
  const [activeFilter, setActiveFilter] = useState("全部");

  useSeo({
    title: "黑瓜吃料 - 蹲点实时瓜 · 新瓜抢先看第一手爆料",
    description:
      "黑瓜吃料专注蹲点实时瓜与最新鲜爆料，全天候更新明星动态、综艺爆料、影视内幕、音乐现场与网红圈热门话题，第一时间整理事件脉络与网友讨论，让你掌握第一手新瓜，蹲点不落空、抢先看不错过。",
    canonical: SITE_URL,
  });

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteMeta.name,
      url: SITE_URL,
      description: siteMeta.intro,
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteMeta.name,
      url: SITE_URL,
      email: siteMeta.email,
      description: siteMeta.intro,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "最新爆料",
      itemListElement: feedItems.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <HotGossip />
        <CategoryGrid onSelect={setActiveFilter} />
        <FeedSection activeFilter={activeFilter} onChange={setActiveFilter} />
        <TimelineSection />
        <VoiceSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
      {structuredData.map((data, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </div>
  );
}